export default "__VITE_ASSET__CqUtoWl3__"